module.exports = __webpack_public_path__ + "static/High_Flyer-66f62636399c47db7233968dd7486863.png";